import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGitab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-gitab';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zM8.542 6.927a10 10 0 0 0-.565.044c-.004.005-.305.846-.669 1.869a77 77 0 0 1-.766 2.092c-.532 1.196-.316 2.484.556 3.319.155.148 1.218.962 2.362 1.808l2.08 1.538.461.002.46.001.54-.403c.296-.222 1.249-.929 2.117-1.57.868-.642 1.68-1.266 1.804-1.387.437-.426.714-1.003.804-1.675.059-.444.007-.869-.163-1.34l-.822-2.285c-.388-1.078-.718-1.972-.733-1.987s-.334-.039-.708-.054l-.68-.027-.604 1.254-.603 1.254-1.409.011-1.41.01-.616-1.26-.616-1.261-.131.006a49 49 0 0 0-.689.041m7.077 3.353c.192.539.405 1.106.474 1.26.111.251.124.321.125.68.002.42-.041.556-.273.873-.047.063-.841.674-1.765 1.358-.924.683-1.79 1.329-1.924 1.435l-.244.191-1.896-1.401c-1.043-.77-1.947-1.458-2.009-1.528a2 2 0 0 1-.22-.328c-.096-.179-.107-.242-.106-.6.001-.372.011-.422.146-.72.079-.176.302-.765.495-1.31.193-.544.363-.99.378-.99s.16.28.322.621l.294.622.346.218.347.219h3.769l.335-.207.336-.208.33-.662c.261-.523.338-.646.361-.583z"
    })
  }));
});
export default SvgGitab;